// 在线评估-汇总
<template>
  <div class="est-box-main" v-if="isRefresh">
    <div class="sub-top-line">
      <el-button type="primary" size="medium" class="btn-icon-36 btn-icon-23c6c8" icon="el-icon-s-data" @click="showStatistics()"></el-button>
      <el-button type="primary" size="medium" class="btn-icon-36 btn-icon-23c6c8" icon="el-icon-s-claim" @click="showToDoList()"></el-button>
      <el-button size="medium" class="btn-icon-36" icon="el-icon-refresh-right" @click="handleRefresh"></el-button>
    </div>
    <div class="mainTable">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <!-- <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th> -->
          <th class="cell thtitle" v-for="(th, thi) in tableNamesS" :key="thi">{{th}}</th>
          <th class="cell thtitle" width="12%">操作</th>
        </tr>
        <tr v-for="(tr, tri) in tabDataCrt.tableData" :key="tri">
          <td class="cell tdcell">{{(pageNo - 1) * pages + tri + 1}}</td>
          <!-- <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi"> -->
          <td class="cell tdcell" v-for="(td, tdi) in rowItemsS" :key="tdi">
            <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
          <td class="cell tdcell">
            <el-button class="text-btn" type="text" size="mini" @click="showDetails(tr)">主表详情</el-button><br>
            <el-button class="text-btn" type="text" size="mini" @click="showProSitTable(tr)">项目情况表</el-button>
            <!-- <el-button class="text-btn" type="text" size="mini" @click="deleteRow(tr)">删除</el-button> -->
            <!-- <el-button type="text" size="mini" @click="makeSure(item)">上传文件</el-button> -->
            <el-button class="text-btn" type="text" size="mini" @click="showLogger(tr)">进度</el-button><br>
          </td>
        </tr>
      </table>
    </div>
    <div class="pro-sit-box" v-if="showProSitFormFlag">
      <proSitForm @closeForm="closeProSitForm" :category="pageCategory" :eiaStatusId="eiaStatusId"></proSitForm>
    </div>
    <!-- other -->
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
    <nut-dialog
      @close="showDetailsDialogFlag = false"
      v-if="showDetailsDialogFlag"
      :visible="showDetailsDialogFlag"
      title="详情"
      :noFooter="true">
      <div class="details-dialog-main">
        <table>
          <template v-for="(title, tindex) in tableNamesD">
            <tr :key="tindex*2">
              <th>{{ title }}</th>
            </tr>
            <tr :key="tindex*2+1">
              <td>{{ detailsRow[rowItemsD[tindex]] }}</td>
            </tr>
          </template>
        </table>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showLoggerFlag = false"
      v-if="showLoggerFlag"
      :visible="showLoggerFlag"
      title="操作进度"
      :noFooter="true">
      <!-- <el-timeline :reverse="reverse">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :timestamp="activity.timestamp">
          {{activity.operator}}<br>
          {{activity.operationType}}<br>
          {{activity.operationDetails}}<br>
          {{activity.operationOpinion}}<br>
        </el-timeline-item>
      </el-timeline> -->
      <div class="logger-dialog-main">
        <table>
          <tr v-for="(activity, index) in activities" :key="index">
            <td>
              <p class="text-time">{{ activity.timestamp }}</p>
              <p class="text-main">{{ activity.operator }}</p>
              <p class="text-main">{{ activity.operationType }}</p>
              <p class="text-main">{{ activity.operationDetails }}</p>
              <p class="text-main">{{ activity.operationOpinion }}</p>
            </td>
          </tr>
        </table>
      </div>
      <div class="bottom-pagination">
        <el-pagination
          hide-on-single-page
          small
          background
          layout="prev, pager, next, jumper"
          @current-change="handleCurrentChangeL"
          :page-size="pagesL"
          :current-page="currentPageL"
          :total="totalNumberL">
        </el-pagination>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showStatisticsFlag = false"
      v-if="showStatisticsFlag"
      :visible="showStatisticsFlag"
      title="项目统计"
      :noFooter="true">
      <div class="details-dialog-main">
        <table class="listTable" width="100%" border="1" align="center">
          <tr>
            <th class="cell thtitle" width="4%">序号</th>
            <!-- <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th> -->
            <th class="cell thtitle" v-for="(th, thi) in tableStatistics.tableNamesS" :key="thi">{{th}}</th>
          </tr>
          <tr v-for="(tr, tri) in tableStatistics.tableData" :key="tri">
            <td class="cell tdcell">{{tri+1}}</td>
            <!-- <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi"> -->
            <td class="cell tdcell" v-for="(td, tdi) in tableStatistics.rowItemsS" :key="tdi">
              <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
              <span v-else>{{tr[td]}}</span>
            </td>
          </tr>
        </table>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showToDoListFlag = false"
      v-if="showToDoListFlag"
      :visible="showToDoListFlag"
      title="待办工作"
      :noFooter="true">
      <div class="details-dialog-main">
        <table class="listTable" width="100%" border="1" align="center">
          <tr>
            <th class="cell thtitle" width="4%">序号</th>
            <!-- <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th> -->
            <th class="cell thtitle" v-for="(th, thi) in tableToDoList.tableNamesS" :key="thi">{{th}}</th>
          </tr>
          <tr v-for="(tr, tri) in tableToDoList.tableData" :key="tri">
            <td class="cell tdcell">{{tri+1}}</td>
            <!-- <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi"> -->
            <td class="cell tdcell" v-for="(td, tdi) in tableToDoList.rowItemsS" :key="tdi">
              <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
              <span v-else>{{tr[td]}}</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="bottom-pagination">
        <el-pagination
          hide-on-single-page
          small
          background
          layout="prev, pager, next, jumper"
          @current-change="handleCurrentChangeT"
          :page-size="pagesT"
          :current-page="currentPageT"
          :total="totalNumberT">
        </el-pagination>
      </div>
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../../api/indexForCoe'
import proSitForm from '../coe-com/proSitForm.vue'
export default {
  data () {
    return {
      pageCategory: '汇总',
      pageRouter: '/estOverview',
      tabType: 'tabA',
      companyName: '',
      // tabData
      tabData: [
        {
          tabTitle: '在线评估-汇总',
          tabIndex: 'tabA',
          tabType: 'table',
          tableNames: [
            '项目名称',
            '委托部门',
            '所在区域',
            '文件类型',
            '文号',
            '当前流程',
            '负责人'
          ],
          rowItems: [
            'entryName',
            'department',
            'area',
            'fileType',
            'docNumber',
            'type',
            'subordinateManager0'
          ],
          api: {
            add: 'cdEiaStatusAdd',
            enquiry: 'cdEiaStatusEnquiry',
            update: 'cdEiaStatusUpdate',
            delete: 'cdEiaStatusDelete',
            extraParam: {
              phone: sessionStorage.getItem('qs_phone'),
              type: '汇总'
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        }
      ],
      tabDataCrt: {},
      tableNamesS: [
        '项目名称',
        // '委托部门',
        // '所在区域',
        // '文件类型',
        // '文号',
        '当前流程',
        '负责人'
      ],
      rowItemsS: [
        'entryName',
        // 'department',
        // 'area',
        // 'fileType',
        // 'docNumber',
        'type',
        'subordinateManager0'
      ],
      tableNamesD: [
        '项目名称',
        '委托部门',
        '所在区域',
        '文件类型',
        '文号',
        '当前流程',
        '负责人'
      ],
      rowItemsD: [
        'entryName',
        'department',
        'area',
        'fileType',
        'docNumber',
        'type',
        'subordinateManager0'
      ],
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true,
      // jindu: false,
      // percentage: 10,
      // text1: '',
      // importFlag: false,
      extaParam: {},
      wordInfo: false,
      detailsRow: {},
      showDetailsDialogFlag: false,
      showLoggerFlag: false,
      activities: [],
      pagesL: 5,
      currentPageL: 1,
      totalNumberL: 0,
      showProSitFormFlag: false,
      showStatisticsFlag: false,
      showToDoListFlag: false,
      eiaStatusId: 0,
      tableStatistics: {
        tabTitle: '在线评估-汇总-项目统计',
        tabIndex: 'tabAS',
        tabType: 'table',
        tableNames: [
          '地区',
          '报告书',
          '报告表',
          '登记表'
        ],
        rowItems: [
          'area',
          'eir',
          'eirf',
          'eiregf'
        ],
        api: {
          enquiry: 'cdEiaStatusStatistics',
          extraParam: {
            phone: sessionStorage.getItem('qs_phone')
          }
        },
        tableData: [{
          id: 0
        }],
        tableNamesS: [
          '地区',
          '报告书',
          '报告表',
          '登记表'
        ],
        rowItemsS: [
          'area',
          'eir',
          'eirf',
          'eiregf'
        ]
      },
      tableToDoList: {
        tabTitle: '在线评估-汇总-待办工作',
        tabIndex: 'tabAT',
        tabType: 'table',
        tableNames: [
          '项目名称',
          '委托部门',
          '所在区域',
          '文件类型',
          '当前流程'
        ],
        rowItems: [
          'entryName',
          'department',
          'area',
          'fileType',
          'type'
        ],
        api: {
          enquiry: 'cdEiaStatusEnquiryOne',
          extraParam: {
            phone: sessionStorage.getItem('qs_phone')
          }
        },
        tableData: [{
          id: 0
        }],
        tableNamesS: [
          '项目名称',
          '委托部门',
          // '所在区域',
          '文件类型',
          '当前流程'
        ],
        rowItemsS: [
          'entryName',
          'department',
          // 'area',
          'fileType',
          'type'
        ]
      },
      pagesT: 10,
      currentPageT: 1,
      totalNumberT: 0
    }
  },
  mounted () {
    this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
    this.getTabData()
  },
  methods: {
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
      }
    },
    handleRefresh () {
      this.getTabData()
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    // closeIF () {
    //   this.importFlag = false
    // },
    // addRow () {
    //   this.importFlag = true
    // },
    // handleSuccess () {
    //   this.$toast.text('上传成功')
    //   this.getTabData()
    // },
    // checkUpload () {
    //   this.$refs.uploadRef.doUpload()
    // },
    // closeWI () {
    //   this.wordInfo = false
    // },
    // addTerm () {
    //   this.wordInfo = true
    // },
    // editRow (row) {
    //   // row.editFlag = true
    //   this.percentage = 0
    //   this.jindu = true
    //   var bianliang = setInterval(() => {
    //     this.percentage = this.percentage + 1
    //     if (this.percentage >= 99) {
    //       clearInterval(bianliang)
    //     }
    //   }, 1000)
    //   api.cdSummaryTableDownload({
    //     id: row.id
    //   }).then(res => {
    //     console.log(res)
    //     if (res.code === 200) {
    //       window.open(res.data)
    //       this.percentage = 100
    //       clearInterval(bianliang)
    //       setTimeout(() => {
    //         this.jindu = false
    //       }, 1000)
    //     } else {
    //       clearInterval(bianliang)
    //       this.text1 = res.message
    //     }
    //     // if (res.code === 40001) {
    //     //   this.jindu = false
    //     // }
    //   })
    // },
    // saveRow (row) {
    //   if (this.tabDataCrt.tabType === 'table') {
    //     var savePusher = {
    //       id: row.id,
    //       ...this.tabDataCrt.api.extraParam
    //     }
    //     this.tabDataCrt.rowItems.forEach(rowItem => {
    //       console.log(row, rowItem, row[rowItem])
    //       savePusher[rowItem] = row[rowItem] || ''
    //     })
    //     api[this.tabDataCrt.api.update](savePusher).then(res => {
    //       console.log(res)
    //       this.$nextTick(() => {
    //         this.isRefresh = true
    //         this.pageNo = 1
    //         this.getTabData()
    //       })
    //     })
    //   }
    // },
    deleteRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.delete]({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    showDetails (row) {
      console.log(row)
      this.detailsRow = row
      this.showDetailsDialogFlag = true
    },
    showLogger (row) {
      console.log(row)
      this.detailsRow = row
      this.showLoggerFlag = true
      this.getJournalt(1)
    },
    getJournalt (pageNo = 1) {
      api.cdEiaJournalEnquiry({
        pages: 5,
        pageNo: pageNo,
        superiorId: this.detailsRow.id
      }).then(res => {
        console.log(res)
        this.totalNumberL = res.data.totalNumber
        var centerArr = []
        if (res.data.totalNumber !== 0) {
          res.data.list.forEach(item => {
            centerArr.push({
              operator: item.operator,
              operationType: item.operationType,
              timestamp: item.operationTime,
              operationDetails: item.operationDetails,
              operationOpinion: item.operationOpinion
            })
            this.activities = centerArr
          })
        } else if (res.data.totalNumber === 0) {
          this.activities = []
        }
        // this.activities.reverse()
      })
    },
    handleCurrentChangeL (currentPage) {
      this.currentPageL = currentPage
      this.getJournalt(this.currentPageL)
    },
    // showReportUpload (row) {
    //   this.eiaStatusId = row.order
    //   this.upOtherFileFlag = true
    // },
    showProSitTable (row) {
      this.eiaStatusId = row.id
      this.showProSitFormFlag = true
    },
    closeProSitForm (changePath) {
      this.showProSitFormFlag = false
      if (changePath) {
        this.$emit('doChangePath', changePath)
      }
    },
    showStatistics () {
      this.showStatisticsFlag = true
      this.getStatisticsTable()
    },
    getStatisticsTable () {
      api[this.tableStatistics.api.enquiry]({
        ...this.tableStatistics.api.extraParam
      }).then(res => {
        console.log(res)
        var tempArr = []
        res.data.list.forEach(item => {
          var arrPusher = {
            id: item.id
          }
          this.tableStatistics.rowItems.forEach(rowItem => {
            arrPusher[rowItem] = item[rowItem]
          })
          tempArr.push(arrPusher)
        })
        this.tableStatistics.tableData = tempArr
        console.log(this.tableStatistics.tableData)
      })
    },
    handleCurrentChangeT (currentPage) {
      this.currentPageT = currentPage
      this.getToDoListTable(this.currentPageT)
    },
    showToDoList () {
      this.showToDoListFlag = true
      this.getToDoListTable()
    },
    getToDoListTable (pageNo = 1) {
      api[this.tableToDoList.api.enquiry]({
        pages: this.pagesT,
        pageNo: pageNo,
        ...this.tableToDoList.api.extraParam
      }).then(res => {
        console.log(res)
        this.totalNumberT = res.data.totalNumber
        var tempArr = []
        res.data.list.forEach(item => {
          var arrPusher = {
            id: item.id
          }
          this.tableToDoList.rowItems.forEach(rowItem => {
            arrPusher[rowItem] = item[rowItem]
          })
          tempArr.push(arrPusher)
        })
        this.tableToDoList.tableData = tempArr
        console.log(this.tableToDoList.tableData)
      })
    }
  },
  components: {
    proSitForm
    // eiaTableImport,
    // protectionMap
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.est-box-main{
  z-index: 0;
  height: 100%;
  overflow-y: auto;
  .sub-top-line {
    height: 36px;
    padding: 10px 0 0 0;
  }
  .mainTable{
    margin: 10px;
    width: calc(100% - 20px);
    word-break: break-all;
    .tableFileCell{
      text-decoration: underline;
      color: #00C;
    }
    .tableFileCell:hover{
      color: #66F;
      text-decoration: none;
    }
    .cell{
      border: 1px #ccc solid;
      text-align: center;
    }
    .thtitle{
      background-color: #fafafa;
      line-height: 24px;
    }
    .tdcell{
      background-color: #fff;
      line-height: 32px;
      padding: 2px;
      .el-input__inner{
        height: 28px!important;
      }
      .text-btn {
        margin: 0!important;
      }
    }
  }
  .bottom-pagination .el-pagination {
    text-align: right;
    margin-top: 6px;
    margin-bottom: 6px;
  }
  .details-dialog-main{
    table {
      word-break: break-all;
      width: 100%;
      height: 100%;
      border-top: 1px #999 solid;
      border-left: 1px #999 solid;
      th {
        color: #000;
      }
      th, td {
        padding: 12px 0;
        color: #333;
        border-right: 1px #999 solid;
      }
      th {
        border-bottom: 1px #999 solid;
      }
      td {
        border-bottom: 1px #999 solid;
      }
    }
  }
  .logger-dialog-main {
    table {
      word-break: break-all;
      width: 100%;
      // height: calc(100% - 32px);
      height: 100%;
      td {
        padding: 8px 0;
        border-bottom: 1px #f3f4f5 solid;
        text-align: left;
      }
    }
    .text-time {
      color: #409EFF;
    }
    .text-main {
      color: #333;
    }
  }
  .pro-sit-box {
    height: 100vh;
    width: 100vw;
    background: #fff;
    position: absolute;
    top: 0;
    z-index: 999;
  }
}
</style>
